var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _g10, _path4, _path5, _path6, _g11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45328 0.599609H3.39453C3.00456 0.599609 2.61842 0.676439 2.25815 0.825711C1.89788 0.974983 1.57056 1.19377 1.29487 1.46958C1.01918 1.74538 0.800525 2.0728 0.651405 2.43313C0.502285 2.79346 0.425617 3.17964 0.425782 3.56961V10.8284L3.23828 12.7809V3.56836C3.23828 3.48336 3.30828 3.41336 3.39453 3.41336H5.45328V0.599609Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45328 0.599609H3.39453C3.00456 0.599609 2.61842 0.676439 2.25815 0.825711C1.89788 0.974983 1.57056 1.19377 1.29487 1.46958C1.01918 1.74538 0.800525 2.0728 0.651405 2.43313C0.502285 2.79346 0.425617 3.17964 0.425782 3.56961V10.8284L3.23828 12.7809V3.56836C3.23828 3.48336 3.30828 3.41336 3.39453 3.41336H5.45328V0.599609Z",
    fill: "#696969"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3828 3.34934C13.3828 3.38434 13.4103 3.41184 13.4453 3.41184H15.9328C16.0203 3.41184 16.0903 3.48309 16.0903 3.56934V11.4918H18.9028V3.56934C18.9028 2.78197 18.59 2.02686 18.0333 1.47011C17.4765 0.913364 16.7214 0.600586 15.9341 0.600586H13.4466C13.43 0.600586 13.4141 0.607171 13.4024 0.618892C13.3906 0.630613 13.3841 0.64651 13.3841 0.663086L13.3828 3.34934Z",
    fill: "#696969"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.425781 10.3391V11.2016C0.426341 13.3692 1.18884 15.4677 2.57994 17.13C3.97104 18.7923 5.90222 19.9128 8.03578 20.2954C8.10252 20.326 8.15869 20.3757 8.19718 20.4382C8.23567 20.5007 8.25476 20.5733 8.25203 20.6466H9.21453V20.4279C9.5102 20.442 9.80637 20.442 10.102 20.4279V20.6466H11.0645C11.0645 20.4491 11.182 20.3429 11.272 20.3004C13.4106 19.922 15.3475 18.8026 16.743 17.1385C18.1385 15.4745 18.9033 13.3721 18.9033 11.2004V10.3379H16.0908V11.2004C16.0908 12.9047 15.4137 14.5393 14.2086 15.7444C13.0034 16.9496 11.3689 17.6266 9.66453 17.6266C7.96018 17.6266 6.32564 16.9496 5.12049 15.7444C3.91533 14.5393 3.23828 12.9047 3.23828 11.2004V10.3379L0.425781 10.3391Z",
    fill: "#696969"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.472 22.0247C23.4962 21.1241 23.871 20.2686 24.5165 19.6402C25.162 19.0118 26.0273 18.6602 26.9282 18.6602C27.8291 18.6602 28.6944 19.0118 29.34 19.6402C29.9855 20.2686 30.3603 21.1241 30.3845 22.0247H33.197C33.1642 20.3838 32.4894 18.8212 31.3173 17.6723C30.1453 16.5234 28.5695 15.8799 26.9282 15.8799C25.287 15.8799 23.7112 16.5234 22.5392 17.6723C21.3671 18.8212 20.6923 20.3838 20.6595 22.0247V26.3447C20.6595 26.9748 20.5354 27.5987 20.2942 28.1809C20.0531 28.763 19.6997 29.2919 19.2541 29.7375C18.8086 30.183 18.2797 30.5365 17.6975 30.7776C17.1154 31.0187 16.4915 31.1428 15.8614 31.1428C15.2313 31.1428 14.6073 31.0187 14.0252 30.7776C13.4431 30.5365 12.9141 30.183 12.4686 29.7375C12.023 29.2919 11.6696 28.763 11.4285 28.1809C11.1873 27.5987 11.0632 26.9748 11.0632 26.3447V20.2397C11.0631 20.1513 11.0442 20.0639 11.0078 19.9833C10.9714 19.9027 10.9183 19.8307 10.852 19.7722L10.0707 19.0809C9.95651 18.9801 9.80937 18.9244 9.65698 18.9244C9.50459 18.9244 9.35745 18.9801 9.24323 19.0809L8.46198 19.7722C8.3957 19.8307 8.3426 19.9027 8.30618 19.9833C8.26976 20.0639 8.25087 20.1513 8.25073 20.2397V26.3447C8.25073 28.3632 9.05256 30.2989 10.4798 31.7262C11.9071 33.1535 13.8429 33.9553 15.8614 33.9553C17.8798 33.9553 19.8156 33.1535 21.2429 31.7262C22.6702 30.2989 23.472 28.3632 23.472 26.3447V22.0247Z",
    fill: "#696969"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1406 19.93V26.1925C10.1405 26.9911 10.2976 27.782 10.6032 28.5199C10.9088 29.2578 11.3567 29.9282 11.9214 30.493C12.4861 31.0577 13.1566 31.5056 13.8945 31.8112C14.6324 32.1167 15.4232 32.2739 16.2219 32.2737H17.9469C18.5188 32.2739 19.0852 32.1614 19.6137 31.9426C20.1421 31.7238 20.6223 31.403 21.0267 30.9986C21.4311 30.5941 21.7519 30.114 21.9707 29.5855C22.1895 29.0571 22.302 28.4907 22.3019 27.9188V21.4475C22.3019 20.3925 22.7209 19.3807 23.4668 18.6345C24.2127 17.8884 25.2244 17.4691 26.2794 17.4688H30.2581",
    stroke: "#696969",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1406 19.93V26.1925C10.1405 26.9911 10.2976 27.782 10.6032 28.5199C10.9088 29.2578 11.3567 29.9282 11.9214 30.493C12.4861 31.0577 13.1566 31.5056 13.8945 31.8112C14.6324 32.1167 15.4232 32.2739 16.2219 32.2737H17.9469C18.5188 32.2739 19.0852 32.1614 19.6137 31.9426C20.1421 31.7238 20.6223 31.403 21.0267 30.9986C21.4311 30.5941 21.7519 30.114 21.9707 29.5855C22.1895 29.0571 22.302 28.4907 22.3019 27.9188V21.4475C22.3019 20.3925 22.7209 19.3807 23.4668 18.6345C24.2127 17.8884 25.2244 17.4691 26.2794 17.4688H30.2581",
    stroke: "#696969",
    strokeWidth: 0.75
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8906 17C30.0369 17.3912 32.3281 18.8362 32.3281 21.4925",
    stroke: "#696969",
    strokeWidth: 0.75
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_iii_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5993 28.3451C33.8298 28.3451 35.638 26.5369 35.638 24.3063C35.638 22.0758 33.8298 20.2676 31.5993 20.2676C29.3688 20.2676 27.5605 22.0758 27.5605 24.3063C27.5605 26.5369 29.3688 28.3451 31.5993 28.3451Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5993 28.3451C33.8298 28.3451 35.638 26.5369 35.638 24.3063C35.638 22.0758 33.8298 20.2676 31.5993 20.2676C29.3688 20.2676 27.5605 22.0758 27.5605 24.3063C27.5605 26.5369 29.3688 28.3451 31.5993 28.3451Z",
    fill: "#696969"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_diii_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6 26.0623C32.57 26.0623 33.3562 25.276 33.3562 24.3061C33.3562 23.3361 32.57 22.5498 31.6 22.5498C30.6301 22.5498 29.8438 23.3361 29.8438 24.3061C29.8438 25.276 30.6301 26.0623 31.6 26.0623Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11426 10.7109V11.1009C2.11426 13.1928 2.94526 15.199 4.42445 16.6782C5.90365 18.1574 7.90986 18.9884 10.0018 18.9884C12.0937 18.9884 14.0999 18.1574 15.5791 16.6782C17.0583 15.199 17.8893 13.1928 17.8893 11.1009V10.7109",
    stroke: "#696969",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11426 10.7109V11.1009C2.11426 13.1928 2.94526 15.199 4.42445 16.6782C5.90365 18.1574 7.90986 18.9884 10.0018 18.9884C12.0937 18.9884 14.0999 18.1574 15.5791 16.6782C17.0583 15.199 17.8893 13.1928 17.8893 11.1009V10.7109",
    stroke: "#696969",
    strokeWidth: 0.65
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44922 3.41211V0.599609H5.72172C6.09468 0.599609 6.45236 0.747767 6.71609 1.01149C6.97981 1.27521 7.12797 1.6329 7.12797 2.00586C7.12797 2.37882 6.97981 2.73651 6.71609 3.00023C6.45236 3.26395 6.09468 3.41211 5.72172 3.41211H4.44922Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44922 3.41211V0.599609H5.72172C6.09468 0.599609 6.45236 0.747767 6.71609 1.01149C6.97981 1.27521 7.12797 1.6329 7.12797 2.00586C7.12797 2.37882 6.97981 2.73651 6.71609 3.00023C6.45236 3.26395 6.09468 3.41211 5.72172 3.41211H4.44922Z",
    fill: "#696969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44922 3.41211V0.599609H5.72172C6.09468 0.599609 6.45236 0.747767 6.71609 1.01149C6.97981 1.27521 7.12797 1.6329 7.12797 2.00586C7.12797 2.37882 6.97981 2.73651 6.71609 3.00023C6.45236 3.26395 6.09468 3.41211 5.72172 3.41211H4.44922Z",
    fill: "#696969"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.47168C16.6787 1.49168 18.0325 1.93668 18.0325 3.56168V9.34293",
    stroke: "#696969",
    strokeWidth: 0.75
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 0.599609V3.41211H13.582C13.2091 3.41211 12.8514 3.26395 12.5877 3.00023C12.3239 2.73651 12.1758 2.37882 12.1758 2.00586C12.1758 1.6329 12.3239 1.27521 12.5877 1.01149C12.8514 0.747767 13.2091 0.599609 13.582 0.599609H14.8545Z",
    fill: "#696969"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 0.599609V3.41211H13.582C13.2091 3.41211 12.8514 3.26395 12.5877 3.00023C12.3239 2.73651 12.1758 2.37882 12.1758 2.00586C12.1758 1.6329 12.3239 1.27521 12.5877 1.01149C12.8514 0.747767 13.2091 0.599609 13.582 0.599609H14.8545Z",
    fill: "#696969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 0.599609V3.41211H13.582C13.2091 3.41211 12.8514 3.26395 12.5877 3.00023C12.3239 2.73651 12.1758 2.37882 12.1758 2.00586C12.1758 1.6329 12.3239 1.27521 12.5877 1.01149C12.8514 0.747767 13.2091 0.599609 13.582 0.599609H14.8545Z",
    fill: "#696969"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2346_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75816 2.15625C2.54197 2.30404 2.36503 2.50226 2.24263 2.73377C2.12023 2.96528 2.05606 3.22312 2.05566 3.485V9.7725",
    stroke: "#696969",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2346_4177",
    x: 0.425781,
    y: 0.0996094,
    width: 5.52747,
    height: 12.6812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.490196 0 0 0 0 0.823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2346_4177",
    x: 13.3828,
    y: 0.100586,
    width: 6.27002,
    height: 11.3914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.494118 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2346_4177",
    x: 0.425781,
    y: 10.3379,
    width: 19.2275,
    height: 10.3088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.172549 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2346_4177",
    x: 8.25073,
    y: 15.8799,
    width: 25.6963,
    height: 18.4754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75,
    dy: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.168627 0 0 0 0 0.443137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2346_4177",
    x: 9.26562,
    y: 16.5938,
    width: 21.4926,
    height: 16.5549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2346_4177",
    x: 28.2695,
    y: 16.145,
    width: 4.93359,
    height: 5.84741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_iii_2346_4177",
    x: 27.4605,
    y: 20.1676,
    width: 8.27751,
    height: 8.27739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.74902 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2346_4177"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.384314 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2346_4177",
    result: "effect2_innerShadow_2346_4177"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.427451 0 0 0 0 0.807843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2346_4177",
    result: "effect3_innerShadow_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_diii_2346_4177",
    x: 29.5937,
    y: 22.3998,
    width: 3.91245,
    height: 3.91245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.392157 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2346_4177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2346_4177",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.329412 0 0 0 0 0.592157 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2346_4177"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 0 0.941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2346_4177",
    result: "effect3_innerShadow_2346_4177"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 0 0.941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2346_4177",
    result: "effect4_innerShadow_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2346_4177",
    x: 1.28931,
    y: 10.2109,
    width: 17.4249,
    height: 9.60254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2346_4177",
    x: 15.489,
    y: 0.596924,
    width: 3.41846,
    height: 9.24609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2346_4177"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2346_4177",
    x: 1.18066,
    y: 1.34668,
    width: 2.28918,
    height: 8.92578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2346_4177"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/appointments.7ab32ba1014d612946f92fd0c4f2e951.svg";
export { ForwardRef as ReactComponent };